import React from "react";
import Form from "../../Components/Form";
import TimePicker from "../../Components/TimePicker";

const StrategySettingsForm = () => {
  return (
    <Form className="w-60 p-2">
      <div className="text-md">:تنضیمات استراتژی</div>
      <div className="flex flex-row justify-start items-center gap-5 text-sm">
        <div className="flex flex-row justify-start items-center gap-2">
          <div>از</div>
          {/* <TimePicker name="" /> */}
        </div>
        <div className="flex flex-row justify-start items-center gap-2"></div>
      </div>
    </Form>
  );
};

export default StrategySettingsForm;
